import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MessageBoxButton, MessageBoxService } from '@saliente/library';
import { cloneDeep } from 'src/app/library/utils';

@Component({
    selector: 'header-help-menu-editor',
    templateUrl: 'header-help-menu-editor.component.html',
    styleUrls: ['header-help-menu-editor.component.scss'],
    standalone: false
})
export class HeaderHelpMenuEditorComponent {
	@Input() helpMenuItems: any[] = [];
	@Output() cancel = new EventEmitter<void>();
	@Output() save = new EventEmitter<any[]>();

	public inEdit = false;
	public editingItem: any = null;
	public editingIndex: number = -1;

	constructor(private messageBoxService: MessageBoxService) {}

	public startEdit(menuItem: any): void {
		this.editingIndex = this.helpMenuItems.indexOf(menuItem);
		this.editingItem = cloneDeep(menuItem);
		this.inEdit = true;
	}

	public saveItemEdit(): void {
		if (this.editingIndex >= 0) {
			this.helpMenuItems[this.editingIndex] = this.editingItem;
		} else {
			this.helpMenuItems.push(this.editingItem);
		}
		this.inEdit = false;
	}

	public deleteItem(index: number): void {
		const self = this;
		const item = self.helpMenuItems[index];
		self.messageBoxService.show({
			title: 'Ștergere resursă',
			message: `Confirmi ștergerea resursei "${item.title}"?`,
			defaultButton: 'no',
			buttons: [MessageBoxButton.yes(), MessageBoxButton.no()],
			callback: function(result: string) {
				if (result === 'yes') {
					self.helpMenuItems.splice(index, 1);
				}
			}
		});
	}

	public drop(event: CdkDragDrop<any[]>): void {
		moveItemInArray(this.helpMenuItems, event.previousIndex, event.currentIndex);
	}

	public moveUp(index: number): void {
		if (index > 0) {
			[this.helpMenuItems[index - 1], this.helpMenuItems[index]] =
			[this.helpMenuItems[index], this.helpMenuItems[index - 1]];
		}
	}
	
	public moveDown(index: number): void {
		if (index < this.helpMenuItems.length - 1) {
			[this.helpMenuItems[index], this.helpMenuItems[index + 1]] =
			[this.helpMenuItems[index + 1], this.helpMenuItems[index]];
		}
	}

	public addItem(): void {
		this.editingIndex = -1;
		this.editingItem = {};
		this.inEdit = true;
	}

	public cancelItemEdit() {
		this.inEdit = false;
	}

	public saveAll(): void {
		this.save.emit(this.helpMenuItems);
	}
}
